module.exports = __webpack_public_path__ + "static/media/servicesBanner.d631eef1.png";